import React from 'react';
import { motion } from 'framer-motion';

const models = [
    {
        id: 1,
        title: "Dedicated Team",
        desc: "A developer works exclusively for your project, fully aligned with your processes and timelines.",
    },
    {
        id: 2,
        title: "Staff Augmentation",
        desc: "Scale your team quickly with our skilled professionals who integrate seamlessly into your existing workflow.",
    },
    {
        id: 3,
        title: "Project Based",
        desc: "End-to-end development for fixed-scope projects with clear deliverables and milestones.",
    },
];

const EngagementModels = () => {
    return (
        <section className="w-full bg-white font-sans">
            <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">

                <div className="mb-12">
                    <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora">
                        Engagement Models
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {models.map((model, index) => (
                        <motion.div
                            key={model.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            // Added 'group' for hover detection and relative positioning
                            className="group relative bg-[#F0F0F0] p-[34px] h-[240px] flex flex-col justify-start transition-shadow duration-300 hover:shadow-xl overflow-hidden"
                        >
                            <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora mb-4">
                                {model.title}
                            </h3>

                            <p className="text-[#49577A] lg:text-[16px] text-[14px] leading-[27px] font-[500] font-graphik">
                                {model.desc}
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#0E2A62]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#F06115] w-0 group-hover:w-full transition-all duration-500 ease-in-out z-10"></div>

                        </motion.div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default EngagementModels;